import { defineComponent as _defineComponent } from 'vue'
import Vue, { watch } from 'vue'
import { ref, withDefaults } from 'vue'

interface PropsType {
  tagList: any[]
  values: []
}


export default /*#__PURE__*/_defineComponent({
  __name: 'm-tag-lake',
  props: {
    tagList: { default: () => [] },
    values: null
  },
  emits: ['onChange'],
  setup(__props: any, { emit: emits }) {

const props = __props as { tagList: any[], values: [] }





const dragItem = ref()
const fileNameFormat = ref('')
const nameArr = ref<any[]>([])
const tagItems = ref<any[]>([])
// 拖拽标签
function onStartDrag(item: any) {
  dragItem.value = item
}
// 放入时触发函数, 深度拷贝拖动的标签dom, 将克隆之后的标签放入盒子, 不影响之前的dom
function onDropOver(event: any) {
  event.target.focus()
  fileNameFormat.value += `{${dragItem.value?.label_name_show}}`
  onAutoFileName()
  Vue.prototype.$nextTick(() => {
    event.preventDefault()
    tagItems.value.push(dragItem.value)
    nameArr.value = tagItems.value.map((item) => item.label_name_show)
    emits(
      'onChange',
      tagItems.value.map((item) => item.label_name)
    )
  })
}

// 生成文件名
function onAutoFileName() {
  return fileNameFormat.value
}

// 拖动放入时, 阻止事件冒泡
function onDragOver(event: any) {
  event.preventDefault()
}

function handleRemoveItem(index: any) {
  let s = fileNameFormat.value.match(/\{(.+?)\}/g)
  if (s) {
    s.splice(index, 1)
    fileNameFormat.value = s.join('')
    tagItems.value.splice(index, 1)
    nameArr.value.splice(index, 1)
    emits(
      'onChange',
      tagItems.value.map((item) => item.label_name)
    )
    onAutoFileName()
  }
}

watch(
  () => props.values,
  (val: string[]) => {
    const tag = val.map((v) =>
      props.tagList
        .map((list) => list.arr)
        .flat(1)
        .find((tag) => tag.label_name == v)
    )
    tagItems.value = tag ? tag : []
    nameArr.value = tagItems.value.map((item) => item.label_name_show)
    fileNameFormat.value = nameArr.value.map((v) => `{${v}}`).join('')
  }
)

return { __sfc: true,props, emits, dragItem, fileNameFormat, nameArr, tagItems, onStartDrag, onDropOver, onAutoFileName, onDragOver, handleRemoveItem }
}

})